import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../redux/usersSlice";
import loadingSpinner from "../../src/assets/svg/loadingSpinner.svg";
import Card from "../components/Card";
import "../styles/usersData.css";

const UsersData = () => {
	const dispatch = useDispatch();
	const {	usersList, loading, isLoggedIn } = useSelector((state) => state.users);

	useEffect(() => {
		// console.log(isLoggedIn)
		// console.log(usersList)
		dispatch(fetchUsers()) // Fetch users when component mounts
	}, [dispatch]);

	return (
		<>
			{loading ? (
				<div className="component_wrapper">
					<img src={loadingSpinner}	alt="Loading..." className="svg"/>
					<p>Loading...</p>
				</div>
			) : usersList?.length > 0 ? (
				<div className="component_wrapper">
					<h2 className="sub_title">User's Data</h2>
					<ul className="data_wrapper">
						{usersList.map((user) => (
							<Card
								key={user._id}
								firstname={user.firstname}
								lastname={user.lastname}
								email={user.email}
								userId={user._id}
								userRole={user.role}
								gender={user.gender}
								address={user.address}
							/>
						))}
					</ul>
				</div>
			) : (
				<div className="component_wrapper">
					<h1 className="error_title">404</h1>
					<p className="sub_title">Page not found!</p>
				</div>
			)}
		</>
	);
};

export default UsersData;
